<template>
	<div>
		<el-card class="box-card">
			<span>账户余额：
				<span style="color:#F56C6C">{{balance.rmb}}</span>（人民币）
				<span v-show="is_show_th"><span style="color:#F56C6C;margin-left: 20px;">{{balance.th}}</span>（泰铢）</span>
				<span v-show="is_show_ph"><span style="color:#F56C6C;margin-left: 20px;">{{balance.ph}}</span>（比索）</span>
				<span v-show="is_show_id"><span style="color:#F56C6C;margin-left: 20px;">{{balance.id}}</span>（印尼比索）</span>
				<span v-show="is_show_vn"><span style="color:#F56C6C;margin-left: 20px;">{{balance.vn}}</span>（越南盾）</span>
			</span>
		</el-card>
		<el-card class="box-card">
			<el-form :inline="true">
				<el-form-item label="订单号:">
					<el-input placeholder="请填写" v-model="listQuery.search.order_number" clearable> </el-input>
				</el-form-item>
				<el-form-item label="交易类型:">
					<el-select style="width: 120px;" v-model="listQuery.search.sign" clearable placeholder="全部">
						<el-option label="支出" value="0"></el-option>
						<el-option label="收入" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-show="is_show_out_select" label="币种">
					<el-select style="width: 120px;" v-model="listQuery.search.currency_type" clearable placeholder="全部">
						<el-option v-for="item in currency" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单状态">
					<el-select style="width: 120px;" v-model="listQuery.search.state" clearable
						placeholder="请选择">
						<el-option v-for="item in state_all" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="日期:">
					<el-date-picker v-model="listQuery.search.start_time" type="date" placeholder="开始日期">
					</el-date-picker>
					-
					<el-date-picker v-model="listQuery.search.end_time" type="date" placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<el-button type="primary" icon="el-icon-search" @click="keySearch">搜索</el-button>
			<el-button type="primary" icon="el-icon-search" style="margin-left:30px;" plain @click="resetSearch">
				重置搜索</el-button>
			<el-button type="success" style="float:right" plain @click="excel" icon="el-icon-download">导出数据</el-button>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column prop="create_time" label="日期">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="type_init" label="类型"></el-table-column>
				<el-table-column prop="currency_type_init" label="币种"></el-table-column>
				<el-table-column prop="money" label="金额">
					<template slot-scope="{row}">
						<span v-if="row.sign == 1" style="color:#67C23A">+ {{row.money}}</span>
						<span v-else style="color:#F56C6C">- {{row.money}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="balance" label="账户余额"> </el-table-column>
				<el-table-column prop="remarks" label="备注"> </el-table-column>
				<el-table-column prop="order_number" label="订单号"> </el-table-column>
				<el-table-column prop="order_state" label="订单状态"> </el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
		</div>
	</div>
</template>

<script>
	import {
		brList,
		excelToken
	} from '@/api/sign_shop'
	import {
		getToken,
	} from '@/tool/cookie'
	import request from '@/tool/request'
	import {
		parseTime,getBaseUrl
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	export default {
		components: {
			Pagination,
			Dtp
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				is_show_in1: false,
				in1_data: [],
				is_show_in2: false,
				in2_data: [],
				is_show_collocation: false,
				collocation_data: [],
				platform_list: [],
				state_all: [],
				balance:{
					rmb:'0.00',
					th:'0.00',
					ph:'0.00',
				},
				is_show_th:false, // 是否显示泰铢
				is_show_ph:false, // 是否显示比索
				currency:[], // 所有币种
				store_all:[], // 所有店铺
			};
		},
		// 计算属性
		computed:{
			// 是否显示币种筛选
			is_show_out_select:function(){
				return (this.is_show_th) || (this.is_show_ph) || (this.is_show_id) || (this.is_show_vn);
			}
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			// 搜索
			keySearch() {
				this.listQuery.page = 1
				this.getList()
			},
			// 重置搜索
			resetSearch() {
				this.resetSearchData()
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						sign: '',
						currency_type:'',
						start_time: '',
						end_time: '',
					},
				}
			},
			getList() { // 获取列表数据
				this.loading = true;
				brList(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;
					
					if(this.listQuery.page == 1){
						this.balance = {
							rmb:r.balance.rmb,
							th:r.balance.th,
							ph:r.balance.ph,
							id:r.balance.id,
							vn:r.balance.vn,
						};
						
						this.currency = r.currency;
						this.state_all = r.state_all;
						
						let ct = r.ct;
						this.is_show_th = ct.is_show_th;
						this.is_show_ph = ct.is_show_ph;
						this.is_show_id = ct.is_show_id;
						this.is_show_vn = ct.is_show_vn;
					}
					
					this.loading = false;
				})
			},
			excel() {
				// 获取exceltoken
				excelToken(Qs.stringify()).then(response => {
					let token = response.result.token;
					if (token) {
						let xid = getToken('login_uid');
						let search = JSON.stringify(this.listQuery.search);
						window.open(getBaseUrl() + "/SignExcel/SignBr?sign_uid=" + xid +
							"&token=" + token + '&search=' + search,
							"_blank");
					}
				})
			}
		}
	}
</script>
<style>
	.el-radio {
		margin-right: 0px;
	}
</style>
